import React from 'react';
import { Container, Grid, useMediaQuery } from '@material-ui/core';
import ForgotPasswordForm from './components/ForgotPassword.form';
import SignInAsGuestLink from 'src/components/SignInAsGuestLink/SignInAsGuestLink.component';
import { useHistory } from 'react-router-dom';
import Routes from '../../Navigator/Navigator.route';
import SuccessScreen from 'src/components/SuccessScreen/SuccessScreen';
import { Header } from './components/ForgotPassword.style';
import { t } from 'src/i18n';
import MainLogo from 'src/components/MainLogo/MainLogo';
import { parseJSON } from 'src/utils/common.util';
import TabletLogoBanner from 'src/assets/images/banner/tablet.png';
import DesktopLogoBanner from 'src/assets/images/banner/desktop.png';
import MobileLogoBanner from 'src/assets/images/banner/mobile.png';

const ForgotPasswordView: React.FC = () => {
  const [
    isRequestResetSuccessful,
    setIsRequestResetSuccessful
  ] = React.useState<boolean>(false);
  const [successMessage, setSuccessMessage] = React.useState<string>('');
  const history = useHistory();

  const handleBackToSignIn = () => {
    history.push(Routes.SignIn);
  };

  const matches = useMediaQuery('(max-width:768px)')
  const isIpadLg = useMediaQuery('(max-width:1024px)')

  const isTablet = matches || isIpadLg
  const isMobile = useMediaQuery('(max-width:600px)');

  let Logo = DesktopLogoBanner;

  if (isMobile) {
    Logo = MobileLogoBanner;
  } else if (isTablet) {
    Logo = TabletLogoBanner;
  }

  return (
    <Container className="login" maxWidth={false} disableGutters={true}>
      {isRequestResetSuccessful ? (
        <>
          <Header>
            <MainLogo logoPath={(parseJSON('tenantInfo') as any).logoPath} />
          </Header>
          <SuccessScreen
            titleMessage={t('general.successRequest')}
            descriptionMessage={successMessage}
            buttonBackMessage={t('forgotPassword.successful.buttonBack')}
            handleGoBack={handleBackToSignIn}
            isShowReturnIcon={false}
            isShowSuccessIcon={true}
          />
        </>
      ) : (
        <Grid container={true} direction={isTablet ? 'row' : 'row-reverse'} className="login__left-wrapper">
          <Grid item={true} sm={isTablet ? 12 : 7}  className="login__right-container">
            <img src={Logo} alt="Home Banner" className="login__banner" />
          </Grid>
          <Grid item={true} sm={isTablet ? 12 : 5} className="login__left-container">
            <div className="login__logo-wrapper">
              <MainLogo logoPath={(parseJSON('tenantInfo') as any).logoPath} />
            </div>
            <div className="login__form-wrapper">
              <ForgotPasswordForm
                setIsRequestResetSuccessful={setIsRequestResetSuccessful}
                setSuccessMessage={setSuccessMessage}
              />
            </div>
            <div />
            <SignInAsGuestLink />
          </Grid>
        </Grid>
      )}
    </Container>
  );
};

export default ForgotPasswordView;
